<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h2>Merci !</h2>
            <p>Votre demande de contact a bien été enregistrée, nous vous rappellerons très prochainement. L’équipe MUR-TRONIC</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    @apply tw-relative tw-bg-white tw-px-6 tw-py-8;

    @screen lg {
        border-radius: 20px;
    }

    h2 {
        @apply tw-font-extrabold tw-text-2xl tw-pb-1;
        color: $main_color;

        @screen lg {
            @apply tw-pb-2;
            font-size: 32px;
        }
    }

    p {
        @apply tw-text-base tw-font-medium;
        line-height: 26px;
    }

    &::before {
        @apply tw-absolute tw-w-full tw-left-0;
        content: '';
        top: -7px;
        height: 100px;
        z-index: -1 !important;
        background-color: $main_color;

        @screen lg {
            border-radius: 20px;
        }
    }
}

</style>
